import React from 'react';

import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const QVPaperStyled = styled(Paper, {
        shouldForwardProp: (prop) => prop !== 'borderRadius' && prop !== 'padding',
        name: 'QVContainer',
        slot: 'Root',
    }) (({ borderRadius = false, padding, theme, flexDirection }) => ({
        borderRadius: 12,
        padding: padding ?? theme.spacing(1),
        margin: theme.spacing(0),
        ...(borderRadius && {
            borderRadius: borderRadius,
        }),
        ...(padding && {
            padding: padding,
        }),
        border: "none",
        flex: "1 1 auto",
        boxShadow: "0 1px 1.5px rgba(0, 0, 0, 0.11) !important",
        display: "flex",
        ...(flexDirection && {
            flexDirection: flexDirection,
        })
}));

export default function QVContainer(props) {
    return (
        <QVPaperStyled {...props}>
            {props.children}
        </QVPaperStyled>
    );
}
